module.exports = __webpack_public_path__ + "img/background2.3ef4ea6a.jpg";